export default class AmplifyApi {
  constructor({ $axios, store }) {
    this.instance = $axios;
    this.orgEnsuredInstance = this.setupOrgEnsuredInstance({ store });
  }

  setupOrgEnsuredInstance({ store }) {
    return new Promise((resolve) => {
      if (store.state.authStore.orgEnsuredState) {
        resolve(this.instance);
      } else {
        store.watch(
          (state) => state.authStore.orgEnsuredState,
          (newState) => {
            if (newState) {
              resolve(this.instance);
            }
          }
        );
      }
    });
  }

  getApiInstance(endpoint) {
    if (endpoint.ensureOrganization) {
      return this.orgEnsuredInstance;
    }
    return this.instance;
  }

  async post(endpoint, data) {
    const { url } = endpoint;
    const instance = await this.getApiInstance(endpoint);
    return instance.post(url, data);
  }

  async get(endpoint, data) {
    const { url } = endpoint;
    const instance = await this.getApiInstance(endpoint);
    return instance.get(url, data);
  }

  async delete(endpoint, data) {
    const { url } = endpoint;
    const instance = await this.getApiInstance(endpoint);
    return instance.delete(url, data);
  }

  async patch(endpoint, data) {
    const { url } = endpoint;
    const instance = await this.getApiInstance(endpoint);
    return instance.patch(url, data);
  }

  async put(endpoint, data, opts) {
    const { url } = endpoint;
    const instance = await this.getApiInstance(endpoint);
    return instance.put(url, data, opts);
  }
}
